import { Tooltip, Button } from '@design-systems/canvas-ui'
import Icon, { BullseyeIcon, LogoutIcon } from '@design-systems/react-icons'
import { faUserLock } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useAuth } from '@praxis/component-auth'

export const ExternalUnauthorizedPage = (props) => {
  const auth = useAuth()
  const { logout } = auth

  return (
    <div id="div-external-unauthorized-page">
      {/* Logout link */}
      <Tooltip
        className="hc8-ma-3x hc8-clr-inverse"
        content={'Logout'}
        location="bottom"
      >
        <Button
          id="btn-unauth-logout"
          data-testid="btn-unauth-logout"
          onClick={() => logout()}
          isIconOnly
          aria-label="Logout"
          variant="ghost"
        >
          <Icon
            id="icon-unauth-logout"
            className="hc8-clr-inverse"
            svg={LogoutIcon}
            size="xl"
          />
        </Button>
      </Tooltip>

      <div className="centered-div bg-shape">
        <Icon svg={BullseyeIcon} size="xl" className="hc8-clr-inverse" />
        <div className="centered-div" style={{ width: '70%' }}>
          <p className="hc8-fs-450 hc8-clr-inverse">
            Oops! Sorry that you are facing this issue. <br />
          </p>
          <FontAwesomeIcon
            className="hc8-ma-6x"
            icon={faUserLock}
            color="#f0f0f0"
            size="10x"
          />
          <p className="hc8-fs-350 hc8-clr-inverse hc8-ma-6x centered-div">
            Please report this in the POL Helpdesk.
          </p>
          <p className="hc8-fs-350 hc8-clr-inverse hc8-pa-none hc8-ma-none centered-div">
            We will get back to you as soon as possible.
          </p>
          <a
            href="https://www.partnersonline.com/page/help"
            target={'_blank'}
            className="hc8-fs-200 hc8-clr-brand"
            rel="noreferrer"
          >
            https://www.partnersonline.com/page/help
          </a>
        </div>
      </div>
    </div>
  )
}
